"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.Model = void 0;
var Preact = __importStar(require("preact"));
var H = __importStar(require("preact/hooks"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var NumericInput = __importStar(require("./A_NumericInputField"));
var Model = __importStar(require("./floorSizeForm/model"));
exports.Model = Model;
var function_1 = require("fp-ts/lib/function");
var E = __importStar(require("fp-ts/Either"));
var formErrors_1 = require("./floorSizeForm/formErrors");
var Component = function (p) {
    // the following represent the form state, not the final values.
    var _a = H.useState((p.widthMeters * 100).toString()), width = _a[0], setWidth = _a[1];
    var _b = H.useState((p.lengthMeters * 100).toString()), length = _b[0], setLength = _b[1];
    var _c = H.useState(undefined), widthError = _c[0], setWidthError = _c[1];
    var _d = H.useState(undefined), lengthError = _d[0], setLengthError = _d[1];
    H.useEffect(function () {
        if (p.onErrorChange !== undefined) {
            p.onErrorChange(widthError !== undefined || lengthError !== undefined);
        }
    }, [widthError, lengthError]);
    H.useEffect(function () {
        var _a = (0, function_1.pipe)(Model.parse(width, length), E.fold(formErrors_1.buildFormErrors, function () { return formErrors_1.emptyFormErrors; })), widthError = _a.widthError, lengthError = _a.lengthError;
        setWidthError(widthError);
        setLengthError(lengthError);
    }, [width, length]);
    return (Preact.h(Box_1.default, { sx: __assign({ marginY: '16px', display: 'grid', gridGap: '24px', backgroundColor: 'background.default', padding: '24px', borderRadius: '8px' }, p.sx) },
        Preact.h(NumericInput.Component, { label: "Width", value: width, ariaDescribedBy: "width-input", onValueChange: function (val) {
                setWidth(val);
                var parsedCm = parseFloat(val);
                if (!Number.isNaN(parsedCm)) {
                    p.onWidthChange(parsedCm / 100);
                }
                else {
                }
            }, unit: "cm", error: widthError }),
        Preact.h(NumericInput.Component, { label: "Length", value: length, ariaDescribedBy: "length-input", onValueChange: function (val) {
                setLength(val);
                var parsedCm = parseFloat(val);
                if (!Number.isNaN(parsedCm)) {
                    p.onLengthChange(parsedCm / 100);
                }
            }, unit: "cm", error: lengthError })));
};
exports.Component = Component;
exports.Component.displayName = 'FloorSizeForm';
